module.exports = __webpack_public_path__ + "img/close.c56388d9.png";